var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8835 5.3125C11.8835 5.3125 11.5215 9.8025 11.3115 11.6938C11.2115 12.5972 10.6535 13.1265 9.73952 13.1432C8.00019 13.1745 6.25885 13.1765 4.52018 13.1398C3.64085 13.1218 3.09218 12.5858 2.99418 11.6985C2.78285 9.7905 2.42285 5.3125 2.42285 5.3125",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8053 3.15951H1.5",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6274 3.15998C10.104 3.15998 9.65338 2.78998 9.55071 2.27732L9.38871 1.46665C9.28871 1.09265 8.95004 0.833984 8.56404 0.833984H5.74204C5.35604 0.833984 5.01738 1.09265 4.91738 1.46665L4.75538 2.27732C4.65271 2.78998 4.20204 3.15998 3.67871 3.15998",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete_icon.7f774b06acc72ea93377daa53b1fe62d.svg";
export { ForwardRef as ReactComponent };